module.exports = __webpack_public_path__ + "08.png?d79c6f55375620fb329823f4bc94e52b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshots/08.png
// module id = 122
// module chunks = 3